
import BaseAuthenticatedView from "@/views/BaseAuthenticatedView.vue";
import { Component, Watch } from "vue-property-decorator";
import ChangePassword from "./components/ChangePassword.vue";
import Vue from "vue";
const DeleteAccountDialog = () =>
  import("./components/DeleteAccountDialog.vue");

@Component({
  components: { ChangePassword, DeleteAccountDialog },
})
export default class AccountSettings extends BaseAuthenticatedView {
  // 👮‍♂️ Validation rules for name field
  private nameFieldRules = [(name: string) => !!name || "Name is required"];

  // 🚩 Flag for whether the provided name is valid
  private get nameFieldIsValid(): boolean {
    return (
      this.username.trim() !== "" &&
      this.username != undefined &&
      this.username !== this.$store.state.userData.username
    );
  }

  // 📦 The user name of the current user
  private username: string = this.$store.state.userData.username;

  // 📦 The user name of the current user
  private email: string = this.$store.state.userData.email;

  // 🚩 Flag for whether the delete account dialog should be shown
  private showDeleteAccountDialog: boolean = false;

  // 🚩 Flag for whether the username is being updated
  private isUpdatingUsername: boolean = false;

  // 📦 The time left before the email should be resent
  private timeLeft: number = 0;

  // 🚩 Flag for whether the timer for validation email should be sent
  private get isTimeLeftUntilResend(): boolean {
    return this.timeLeft > 0;
  }

  // 👂 Listener for changes in the time left for the
  @Watch("timeLeft")
  onTimeLeftChange(val: number, oldVal: number) {
    setTimeout(() => (this.timeLeft = this.timeLeft - 1), 1000);
  }

  /**
   * 🚀 Updates the user's username on the API
   */
  private updateUsername() {
    this.isUpdatingUsername = true;
    Vue.prototype.$api
      .post("/api/v1/users/changename", {
        name: this.username,
      })
      .then((respone: any) => {
        this.$store.state.userData.username = this.username;
        super.showSuccessSnackbar("Your name was successfully updated!");
      })
      .finaly(() => (this.isUpdatingUsername = false));
  }

  /**
   * 🚀📩 Re-sends an email that allows for email verification of the user
   */
  private resendVerificationEmail() {
    this.timeLeft = 30;
    Vue.prototype.$api.post("/api/v1/validationemail", null).then(() => {
      this.showSuccessSnackbar(
        "Email for verifying your email address was successfully sent!"
      );
    });
  }
}
